
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AgencyEmployeeResource,
  CreateAgencyEmployeeRequest,
  UpdateAgencyEmployeeRequest,
} from '../models';
import {
    AgencyEmployeeResourceFromJSON,
    AgencyEmployeeResourceToJSON,
    CreateAgencyEmployeeRequestFromJSON,
    CreateAgencyEmployeeRequestToJSON,
    UpdateAgencyEmployeeRequestFromJSON,
    UpdateAgencyEmployeeRequestToJSON,
} from '../models';

export interface CreateAgencyEmployeeOperationRequest {
    agencyId: string;
    createAgencyEmployeeRequest: CreateAgencyEmployeeRequest;
}

export interface DeleteAgencyEmployeeRequest {
    agencyId: string;
    employeeId: string;
}

export interface ListAgencyEmployeesRequest {
    agencyId: string;
}

export interface UpdateAgencyEmployeeOperationRequest {
    agencyId: string;
    employeeId: string;
    updateAgencyEmployeeRequest: UpdateAgencyEmployeeRequest;
}

/**
 * 
 */
export class AgencyEmployeesApi extends runtime.BaseAPI {

    /**
     * Create a new employee in the agency directory
          */
    async createAgencyEmployeeRaw(requestParameters: CreateAgencyEmployeeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AgencyEmployeeResource>> {
        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling createAgencyEmployee().'
            );
        }

        if (requestParameters['createAgencyEmployeeRequest'] == null) {
            throw new runtime.RequiredError(
                'createAgencyEmployeeRequest',
                'Required parameter "createAgencyEmployeeRequest" was null or undefined when calling createAgencyEmployee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AgencyEmployeeResource>({
            path: `/api/v1/agencies/{agencyId}/employees`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters['agencyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAgencyEmployeeRequestToJSON(requestParameters['createAgencyEmployeeRequest']),
        }, initOverrides);

        if (response._data) { response._data=AgencyEmployeeResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a new employee in the agency directory
          */
    async createAgencyEmployee(requestParameters: CreateAgencyEmployeeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AgencyEmployeeResource> {
        const response = await this.createAgencyEmployeeRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Soft-delete an employee
          */
    async deleteAgencyEmployeeRaw(requestParameters: DeleteAgencyEmployeeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling deleteAgencyEmployee().'
            );
        }

        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling deleteAgencyEmployee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/api/v1/agencies/{agencyId}/employees/{employeeId}`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters['agencyId']))).replace(`{${"employeeId"}}`, encodeURIComponent(String(requestParameters['employeeId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Soft-delete an employee
          */
    async deleteAgencyEmployee(requestParameters: DeleteAgencyEmployeeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAgencyEmployeeRaw(requestParameters, initOverrides);
    }

    /**
     * List all active employees for the agency
          */
    async listAgencyEmployeesRaw(requestParameters: ListAgencyEmployeesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<AgencyEmployeeResource>>> {
        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling listAgencyEmployees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<AgencyEmployeeResource>>({
            path: `/api/v1/agencies/{agencyId}/employees`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters['agencyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(AgencyEmployeeResourceFromJSON);
        return response;
    }

    /**
     * List all active employees for the agency
          */
    async listAgencyEmployees(requestParameters: ListAgencyEmployeesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<AgencyEmployeeResource>> {
        const response = await this.listAgencyEmployeesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update an existing employee
          */
    async updateAgencyEmployeeRaw(requestParameters: UpdateAgencyEmployeeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AgencyEmployeeResource>> {
        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling updateAgencyEmployee().'
            );
        }

        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling updateAgencyEmployee().'
            );
        }

        if (requestParameters['updateAgencyEmployeeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAgencyEmployeeRequest',
                'Required parameter "updateAgencyEmployeeRequest" was null or undefined when calling updateAgencyEmployee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AgencyEmployeeResource>({
            path: `/api/v1/agencies/{agencyId}/employees/{employeeId}`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters['agencyId']))).replace(`{${"employeeId"}}`, encodeURIComponent(String(requestParameters['employeeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAgencyEmployeeRequestToJSON(requestParameters['updateAgencyEmployeeRequest']),
        }, initOverrides);

        if (response._data) { response._data=AgencyEmployeeResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Update an existing employee
          */
    async updateAgencyEmployee(requestParameters: UpdateAgencyEmployeeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AgencyEmployeeResource> {
        const response = await this.updateAgencyEmployeeRaw(requestParameters, initOverrides);
        return response._data;
    }

}
